import { v4 as uuidv4 } from "uuid";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import { getSalesBlockPrimaryStyleOptions } from "@circle-react-shared/BuilderUI/DefaultBlocks/Sales/constants";
import {
  createH2Block,
  createPBlock,
} from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/textBlocksHelpers";
import { getBackgroundColorOptions } from "@circle-react-shared/BuilderUI/utils/buttonStyleHelpers";

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "TestimonialsBlock1",
  props: {
    content: {
      prop: "children",
      type: "children",
      value: [
        createH2Block({
          text: "Success stories, real transformation",
        }),
        createPBlock({
          text: "Discover how Clarity Coaching has empowered leaders to overcome challenges, build confidence, and achieve career breakthroughs. These success stories showcase real transformations, highlighting the impact of expert coaching, community support, and a proven framework for leadership growth.",
        }),
      ],
    },
    styles: {
      prop: "styles",
      type: "styles",
      value: {
        ...getSalesBlockPrimaryStyleOptions(),
        backgroundColor: getBackgroundColorOptions({
          defaultValue: "var(--theme-website-color-background-secondary)",
        }),
      },
    },
  },
};
